import { TabbedGroup } from "../../../components/TabbedGroup";
import { AdminPermissions as AP } from "../../../lib/data";
import Analytics from "../Analytics";
import Funnel from "../Funnel";
import Leaderboard from "../Leaderboard";

export default function Growth() {
  return (
    <TabbedGroup
      tabs={[
        { value: "analytics", label: "Analytics", permission: AP.MANAGE_USERS, element: <Analytics /> },
        { value: "funnel", label: "Member Funnel", permission: AP.MANAGE_USERS, element: <Funnel /> },
        { value: "leaderboard", label: "Leaderboard", permission: AP.MANAGE_USERS, element: <Leaderboard /> },
      ]}
    />
  );
}
